import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

export interface Popup {
  title: string
  message: string
  link?: string
  confirm?: boolean
  confirmLabel?: string
  cancelLabel?: string
  duration?: number
  closeLabel?: string
}

@Component({
  selector: 'app-popup',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, RouterModule],
  templateUrl: './popup.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './popup.component.css'
})
export class PopupComponent {
  content = inject<Popup>(MAT_DIALOG_DATA);
}
